export { default } from './add-to-wishlist-button';